
  import { Component, Prop, Vue } from 'vue-property-decorator'
  import { FilterField } from '@/entities/public/Resource/interfaces'
  import GCostField from '@/components/core/input/GCostField.vue'
  import GDatePicker from '@/components/core/input/GDatePicker.vue'
  import dayjs from 'dayjs'
  import utc from 'dayjs/plugin/utc'
  import { fixDate } from '@/utils/general'

  dayjs.extend(utc)

@Component({
  components: {
    GDatePicker,
    GCostField,
    VTextField: () => import('vuetify/lib/components/VTextField'),
    VCombobox: () => import('vuetify/lib/components/VCombobox'),
    VDivider: () => import('vuetify/lib/components/VDivider'),
  },
})
  export default class AdvanceSearch extends Vue {
  @Prop({ required: true }) filterFields!: FilterField[];

  // Almacenar valores internos en lugar de depender de filterFields directamente
  internalValues: Array<any> = [];

  created () {
    // Inicializamos los valores internos según los campos de filtro
    this.internalValues = this.filterFields.map(field => field.value || null)
  }

  get isSearchEnabled (): boolean {
    return this.internalValues.some(value => value !== undefined && value !== null && value !== '')
  }

  getComponentType (field: FilterField): string {
    return field.component || 'v-text-field'
  }

  onClear () {
    this.internalValues = this.filterFields.map(() => null)
  }

  onCancel () {
    this.$emit('cancel')
  }

  onSearch () {
    const searchCriteria = this.filterFields.map((field, index) => ({
      ...field,
      value: this.transformValue(this.internalValues[index], field.component),
    }))

    this.$emit('search', searchCriteria)
  }

  transformValue (value, component) {
    if (component === 'g-date-picker' && value) {
      const startOfDay = dayjs(fixDate(value)).startOf('day').local().utc().toISOString() // Inicio del día en UTC
      const endOfDay = dayjs(fixDate(value)).endOf('day').local().utc().toISOString()
      return {
        _gte: startOfDay,
        _lte: endOfDay,
      }
    }
    return value
  }
  }
